'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ActionButtons } from '../../components/action-buttons/action-buttons';
import styles from './shared-styles.module.scss';
export const solarRequestType = [
    {
        value: 'B2B Purchasing',
        title: 'Photovoltaik kaufen (Purchasing)'
    },
    {
        value: 'B2B Contracting',
        title: 'Photovoltaik nutzen (Contracting)'
    },
    {
        value: 'B2B undecided',
        title: 'Lösungsoffene Beratung'
    }
];
export const SolarRequestTypeStep = ({ funnelState })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: styles['funnel-step'],
        children: /*#__PURE__*/ _jsx(ActionButtons, {
            columns: 1,
            currentValue: funnelState.formValues.solarRequestType,
            name: "solarRequestType",
            options: solarRequestType,
            errorMessage: funnelState.errors?.solarRequestType?.solarRequestType,
            required: true
        })
    });
};

//# sourceMappingURL=solar-request-type.js.map